import { initializeRouter } from './app-router';
import { UINotifications } from './utilities/errors';
import { bounceToTop } from './app-router';
import { AuthService } from './actions/auth/api-services';
import { createMaintenancePage } from './screens/maintenance-page';

// Maintenance mode flag
const underMaintenance = true;

// Add Font Awesome
const fontAwesomeLink = document.createElement('link');
fontAwesomeLink.rel = 'stylesheet';
fontAwesomeLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css';
document.head.appendChild(fontAwesomeLink);

async function main() {
  //console.log("Starting app initialization");

  // Check maintenance mode first
  if (underMaintenance) {
    //console.log("Application is in maintenance mode");
    const appContainer = document.querySelector('#app');
    if (appContainer) {
      appContainer.innerHTML = '';
      appContainer.appendChild(createMaintenancePage());
    }
    // Set 503 status code
    document.title = '503 Service Unavailable';
    return;
  }

  // Initialize app
  initializeRouter();
  bounceToTop();

  // Mount initial app container
  const appContainer = document.querySelector('#app');
  if (!appContainer) {
    throw new Error('App container not found');
  }

  // Check for refresh messages
  UINotifications.checkForRefreshMessage();

  // Validate session if user ID exists
  const userId = localStorage.getItem('userId');
  if (userId) {
    //console.log("Found user ID, validating session...");
    const isValid = await AuthService.validate();
    if (!isValid) {
      //console.log("Session invalid, clearing user ID");
      localStorage.clear(); // Clear all localStorage
      document.cookie.split(";").forEach(cookie => {
        document.cookie = cookie
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
      window.location.reload();
      return;
    }
  }

  //console.log("App initialization complete");
}

// Start the application when DOM is ready
document.addEventListener('DOMContentLoaded', main);
